import { render } from "./UserSelectorWidget.vue?vue&type=template&id=7911c332"
import script from "./UserSelectorWidget.vue?vue&type=script&lang=js"
export * from "./UserSelectorWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__